import { InfoV2Icon } from '@p2p/assets/svg';
import { Typography } from '@p2p/components';

import { InfoBlockItem } from '../InfoBlockItem';
import { infoBlockCards } from './InfoBlock.constants';
import styles from './InfoBlock.module.scss';

export const InfoBlock = () => {
  return (
    <div className={styles.info}>
      <div className={styles.infoHeadingContainer}>
        <div>
          <InfoV2Icon />
        </div>
        <div className={styles.infoHeading}>
          <Typography variant="h3" color="heading">
            Пока мы ищем реквизит – прочтите краткую инструкцию
          </Typography>
          <Typography variant="text-m-medium">
            Тщательно сверяйте реквизиты получателя перед отправкой. По правилам банков такие
            платежи не подлежат возврату
          </Typography>
        </div>
      </div>

      <div className={styles.infoSteps}>
        {infoBlockCards.map((card) => (
          <InfoBlockItem
            key={card.title}
            step={card.step}
            title={card.title}
            pathImg={card.pathImg}
          />
        ))}
      </div>
    </div>
  );
};
